var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-4"},[_c('div',{staticClass:"p-4 border-bottom"},[_c('h5',{staticClass:"text-black-90 titulo_nitro"},[_vm._v("\n      Calendário\n    ")]),_vm._v(" "),_c('h6',{staticClass:"titulo_nitro text-gray-400"},[_vm._v("\n      Novidades da semana\n    ")])]),_vm._v(" "),_c('events-calendar',{attrs:{"period":"week"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }